import { render, staticRenderFns } from "./DashboardUnpf.vue?vue&type=template&id=40b53cde&"
import script from "./DashboardUnpf.vue?vue&type=script&lang=js&"
export * from "./DashboardUnpf.vue?vue&type=script&lang=js&"
import style0 from "./DashboardUnpf.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports